<template>
    <section>
        <sort :sorts="sorts" first="推荐" path="videos"></sort>

        <div class="video-box df jcsb">
            <div v-for="v in videos" :key="v.id" @click="redirect(v)" class="video-link">
                <div class="video-thumb" :style="`background-image: url(${v.thumb})`">
                    <div v-if="v.type !== 5" class="video-meta">
                        <div class="video-meta-play">
                            <i class="icon-play"></i>{{$view(v.views)}}
                        </div>
                        <i class="icon-comment"></i>{{v.comments}}
                    </div>
                </div>
                <div class="video-title">{{v.title}}</div>
            </div>
        </div>

        <a v-if="!isLoading" class="empty download" href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app">查看全部视频，请下载 Vhiphop 客户端 >></a>
    </section>
</template>

<script>
    import sort from '../base/Nav';

    export default {
        components: {
            sort,
        },
        data: () => ({
            sorts: ['编舞', 'Popping', 'Hiphop', 'Jazz', 'Locking', 'Waacking'],
            videos: [],
            isLoading: true,
        }),
        computed: {
            sort() {
                return +this.$route.query.sort || 0;
            },
        },
        methods: {
            redirect(v) {
                if (!v.type || v.type === 1) return this.$router.push(`/videos/${v.id}`);
                if (v.type === 2) return this.$router.push(`/contests/${v.id}`);
                if (v.type === 3) return this.$router.push(`/info/${v.id}`);
                window.open(v.link);
            },
        },
        beforeRouteUpdate(to, from, next) {// 路由改变前，组件就已经渲染完了
            const {sort} = to.query;

            this.api.get('videos', {sort: +sort || 0}).then(e => this.videos = e, this.err);
            next();
            this.$share('视频');
        },
        async beforeMount() {
            const {api, sort} = this;

            await Promise.all([
                api.get('home/sorts').then(e => this.sorts = e),
                api.get('videos', {sort}).then(e => this.videos = e),
            ]).catch(this.err);

            this.isLoading = false;
            this.$share('视频');
        },
    }
</script>

<style scoped>
    @import '../../../static/css/home/video.css';
    @import '../../../static/css/home/video-list.css';
</style>


// WEBPACK FOOTER //
// src/components/home/Video.vue